var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToDo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "#E0F8FF",
    stroke: "#00A3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9433 13.0559C22.601 12.7133 22.0567 12.6917 21.6886 12.9916C21.6354 13.035 21.6766 12.9968 20.8662 13.8072L22.9698 15.9109L23.7259 15.1643C24.0914 14.7987 24.0914 14.204 23.7259 13.8384L22.9433 13.0559Z",
    fill: "#00A3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5524 18.1611L15.315 20.8127C15.2316 20.9914 15.2689 21.2031 15.4083 21.3424C15.5477 21.4818 15.7594 21.5191 15.938 21.4357L18.5897 20.1983C18.6946 20.1493 18.377 20.4466 22.3028 16.5697L20.2034 14.4702C16.3109 18.3627 16.6024 18.0541 16.5524 18.1611V18.1611Z",
    fill: "#00A3FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3794 20.7741C19.2646 20.8874 19.1322 20.9795 18.9861 21.0477L16.3344 22.2852C15.813 22.5285 15.1759 22.4358 14.7454 22.0052C14.3288 21.5887 14.2163 20.9501 14.4654 20.4161L15.7029 17.7644C15.7724 17.6155 15.8666 17.481 15.9828 17.3648L19.9692 13.3783V9.40625C19.9692 8.63084 19.3384 8 18.563 8H9.40674C8.63133 8 8.00049 8.63084 8.00049 9.40625V22.5938C8.00049 23.3692 8.63133 24 9.40674 24H18.563C19.3384 24 19.9692 23.3692 19.9692 22.5938V20.1915L19.3794 20.7741ZM10.5005 11.0312H17.5005C17.7594 11.0312 17.9693 11.2411 17.9693 11.5C17.9693 11.7589 17.7594 11.9688 17.5005 11.9688H10.5005C10.2416 11.9688 10.0318 11.7589 10.0318 11.5C10.0318 11.2411 10.2416 11.0312 10.5005 11.0312ZM10.5005 13.5312H16.0005C16.2594 13.5312 16.4693 13.7411 16.4693 14C16.4693 14.2589 16.2594 14.4688 16.0005 14.4688H10.5005C10.2416 14.4688 10.0318 14.2589 10.0318 14C10.0318 13.7411 10.2416 13.5312 10.5005 13.5312ZM10.0318 16.5C10.0318 16.2411 10.2416 16.0312 10.5005 16.0312H14.5005C14.7594 16.0312 14.9693 16.2411 14.9693 16.5C14.9693 16.7589 14.7594 16.9688 14.5005 16.9688H10.5005C10.2416 16.9688 10.0318 16.7589 10.0318 16.5Z",
    fill: "#00A3FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToDo);
export default __webpack_public_path__ + "static/media/To Do.a1073881e16158eefb59412d50f7d33f.svg";
export { ForwardRef as ReactComponent };